import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/faqs";

export const HomeFAQ = () => (
  <section className="border-t border-navy-900/10 bg-white py-24 sm:py-32" data-testid="home-faq-section">
    <div className="container-site grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <SectionHeading
          chapter="11"
          eyebrow="Questions, Answered"
          title="What NRI Owners Ask Us."
          copy="Straight answers before you even pick up the phone."
        />
        <Reveal delay={0.15}>
          <Link to="/faq" className="btn-outline-navy mt-8" data-testid="home-faq-all">
            View All FAQs <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full" data-testid="home-faq-accordion">
          {FAQS.slice(0, 6).map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-navy-900/10">
              <AccordionTrigger
                className="py-5 text-left font-display text-base font-bold tracking-tight text-navy-900 hover:text-gold-600 hover:no-underline sm:text-lg"
                data-testid={`home-faq-q-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-muted-foreground sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
